<template>
<div class="chapter">
<div class="inner_page">
<p>
<img alt="Cover Page" height="740" src="images/cover.jpg" width="525"/>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// coverpage.vue?725322fe